import { render, staticRenderFns } from "./BestCandidateInput.vue?vue&type=template&id=51842f8d&scoped=true"
import script from "./BestCandidateInput.vue?vue&type=script&lang=js"
export * from "./BestCandidateInput.vue?vue&type=script&lang=js"
import style0 from "./BestCandidateInput.vue?vue&type=style&index=0&id=51842f8d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51842f8d",
  null
  
)

export default component.exports
import QSelect from 'quasar/src/components/select/QSelect.js';
import QRadio from 'quasar/src/components/radio/QRadio.js';
import QItem from 'quasar/src/components/item/QItem.js';
import QItemSection from 'quasar/src/components/item/QItemSection.js';
import QRating from 'quasar/src/components/rating/QRating.js';
import QChip from 'quasar/src/components/chip/QChip.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QSelect,QRadio,QItem,QItemSection,QRating,QChip});
